module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_7042.32fa8bb5.png";